// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import parse from "html-react-parser";

// class ProductSliderV2 extends Component {
//   render() {
//     let publicUrl = process.env.PUBLIC_URL + "/";

//     return (
//       <div
//         className="ltn__search-by-place-area before-bg-top bg-image-top--- pt-115 pb-70"
//         data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}
//       >
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="section-title-area ltn__section-title-2--- text-center---">
//                 <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
//                   We put our customers first
//                 </h6>
//                 <h1 className="section-title">
//                   Our Focus Area
//                   <br />
//                 </h1>
//               </div>
//             </div>
//           </div>
//           <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
//             <div className="col-lg-4">
//               <div className="ltn__search-by-place-item">
//                 <div className="search-by-place-img">
//                   <Link
//                   //   to="/product-details"
//                   >
//                     <img
//                       src={publicUrl + "assets/img/product-3/focus-1.png"}
//                       alt="#"
//                     />
//                   </Link>
//                   <div className="search-by-place-badge">
//                     <ul>
//                       <li>Powerbank</li>
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="search-by-place-info">
//                   <h4>
//                     <Link
//                     // to="/product-details"
//                     >
//                       Performance and Reliability
//                     </Link>
//                   </h4>
//                   <p>
//                     Ensure high-capacity, long-lasting batteries with consistent
//                     performance for uninterrupted power at home (Powerwall) and
//                     extended range for e-bikes.
//                   </p>
//                   {/* <h6>
//                     <Link to="/contact">San Francisco</Link>
//                   </h6>
//                   <div className="search-by-place-btn">
//                     <Link to="/product-details">
//                       View Property <i className="flaticon-right-arrow" />
//                     </Link>
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-4">
//               <div className="ltn__search-by-place-item">
//                 <div className="search-by-place-img">
//                   <Link
//                   //   to="/product-details"
//                   >
//                     <img
//                       src={publicUrl + "assets/img/product-3/focus-2.png"}
//                       alt="#"
//                     />
//                   </Link>
//                   <div className="search-by-place-badge">
//                     <ul>
//                       <li>Sustainable</li>
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="search-by-place-info">
//                   <h4>
//                     <Link
//                     // to="/product-details"
//                     >
//                       Sustainability and Innovation
//                     </Link>
//                   </h4>
//                   <p>
//                     Focus on eco-friendly designs with advanced technologies,
//                     offering energy-efficient and sustainable solutions for
//                     modern living and commuting.
//                   </p>
//                   {/* <h6>
//                     <Link to="/contact">New York</Link>
//                   </h6>
//                   <h4>
//                     <Link to="/product-details">Pacific Heights Area</Link>
//                   </h4>
//                   <div className="search-by-place-btn">
//                     <Link to="/product-details">
//                       View Property <i className="flaticon-right-arrow" />
//                     </Link>
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-4">
//               <div className="ltn__search-by-place-item">
//                 <div className="search-by-place-img">
//                   <Link
//                   //   to="/product-details"
//                   >
//                     <img
//                       src={publicUrl + "assets/img/product-3/focus-3.png"}
//                       alt="#"
//                     />
//                   </Link>
//                   <div className="search-by-place-badge">
//                     <ul>
//                       <li>Reliable</li>
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="search-by-place-info">
//                   <h4>
//                     <Link
//                     // to="/product-details"
//                     >
//                       Safety and Convenience
//                     </Link>
//                   </h4>
//                   <p>
//                     Prioritize user safety with robust protection features and
//                     provide easy installation, maintenance, and compatibility
//                     with existing systems.
//                   </p>
//                   {/* <h6>
//                     <Link to="/contact">Sedona, Arizona</Link>
//                   </h6>
//                   <h4>
//                     <Link to="/product-details">Noe Valley Zones</Link>
//                   </h4>
//                   <div className="search-by-place-btn">
//                     <Link to="/product-details">
//                       View Property <i className="flaticon-right-arrow" />
//                     </Link>
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="col-lg-4">
//               <div className="ltn__search-by-place-item">
//                 <div className="search-by-place-img">
//                   <Link to="/product-details">
//                     <img
//                       src={publicUrl + "assets/img/product-3/2.jpg"}
//                       alt="#"
//                     />
//                   </Link>
//                   <div className="search-by-place-badge">
//                     <ul>
//                       <li>5 Properties</li>
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="search-by-place-info">
//                   <h6>
//                     <Link to="/contact">New York</Link>
//                   </h6>
//                   <h4>
//                     <Link to="/product-details">Pacific Heights Area</Link>
//                   </h4>
//                   <div className="search-by-place-btn">
//                     <Link to="/product-details">
//                       View Property <i className="flaticon-right-arrow" />
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div> */}
//             {/*  */}
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default ProductSliderV2;

import React, { Component } from "react";
import { Link } from "react-router-dom";

class ProductSliderV2 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    // Array of product slider items
    const sliderItems = [
      {
        id: 1,
        image: "assets/img/product-3/focus-3.webp",
        badge: "Reliable",
        title: "Safety and Convenience",
        description:
          "Prioritize safety with robust protection, easy installation, maintenance, and compatibility with existing systems.",
      },

      {
        id: 2,
        image: "assets/img/product-3/focus-1.webp",
        badge: "Powerwall",
        title: "Performance and Reliability",
        description:
          "Ensure high-capacity, with consistent performance for uninterrupted power at home.",
      },
      {
        id: 3,
        image: "assets/img/product-3/focus-2.webp",
        badge: "Sustainable",
        title: "Sustainability and Innovation",
        description:
          "Focus on eco-friendly designs with advanced technologies, offering energy-efficient and sustainable solutions.",
      },
    ];

    return (
      <div
        className="ltn__search-by-place-area before-bg-top bg-image-top--- pt-50 pb-70"
        data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center---">
                {/* <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
                  We put our customers first
                </h6> */}
                <h1 className="section-title" style={{ textAlign: "center" }}>
                  Focusing on Your Needs
                  <br />
                </h1>
              </div>
            </div>
          </div>
          <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
            {sliderItems.map((item) => (
              <div className="col-lg-4" key={item.id}>
                <div
                  className="ltn__search-by-place-item"
                  style={{ borderRadius: "20px" }}
                >
                  <div className="search-by-place-img">
                    {/* <Link
                    > */}
                    <img src={publicUrl + item.image} alt="#" />
                    {/* </Link> */}
                    {/* <div className="search-by-place-badge">
                      <ul>
                        <li>{item.badge}</li>
                      </ul>
                    </div> */}
                  </div>
                  <div className="search-by-place-info">
                    <h4>
                      {/* <Link
                      Add the link URL here if needed
                      > */}
                      {item.title}
                      {/* </Link> */}
                    </h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default ProductSliderV2;
